import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const StarSolidIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path d="M6.693 1.589c.544-1.068 2.07-1.068 2.615 0l1.561 3.064 3.394.54c1.183.189 1.654 1.638.808 2.486l-2.43 2.436.536 3.4c.186 1.184-1.048 2.08-2.115 1.536L8 13.49l-3.061 1.56c-1.068.543-2.302-.352-2.115-1.536l.535-3.4L.93 7.678c-.845-.847-.374-2.296.809-2.485l3.394-.54z" />
  </svg>
);
StarSolidIcon.id = 'StarSolidIcon';
StarSolidIcon.displayName = 'StarSolidIcon';
export default StarSolidIcon;
